import { useState, useEffect } from 'react';
import { blogApiClient, type ApiPostDetail } from '@/lib/blogApiClient';
import type { PostSummary } from './usePosts';

interface PostState {
  post: ApiPostDetail | null;
  related: PostSummary[];
  isLoading: boolean;
  error: string | null;
}

/**
 * Fetch a single post by slug.
 *
 * Fetch a single post from the blog API.
 */
export function usePost(slug: string): PostState {
  const [state, setState] = useState<PostState>({
    post: null,
    related: [],
    isLoading: true,
    error: null,
  });

  useEffect(() => {
    blogApiClient.getPost(slug)
      .then((post) => {
        setState({ post, related: [], isLoading: false, error: null });
      })
      .catch((err: unknown) => {
        setState({ post: null, related: [], isLoading: false, error: String(err) });
      });
  }, [slug]);

  return state;
}
